import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=c5ba8d9c&scoped=true"
import script from "./settings.ts?vue&type=script&lang=js&external"
export * from "./settings.ts?vue&type=script&lang=js&external"
import style0 from "./settings.vue?vue&type=style&index=0&id=c5ba8d9c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba8d9c",
  null
  
)

export default component.exports